import {AmountInputComponentStyle, LabelStyle} from "./input.style";
import {InputComponent, InputComponentProps} from "./input.component";
import React from "react";
import {Col, Grid} from "../../theme/styles";


export interface AmountInputProps extends InputComponentProps {
    onValueChange?: (rawNumber: string, value: string, isValid: boolean) => void,
    label?: string;
    message?: string;
    name?: string;
    min?: number;
    max?: number;
    wrapperProps?: React.HTMLAttributes<HTMLDivElement>,
    includeGridBtn?: boolean
}

export const AmountInputComponent = ({
                                         value: formValue,
                                         onChange: formOnChange,
                                         includeGridBtn,
                                         wrapperProps,
                                         label,
                                         message,
                                         name,
                                         min = 50,
                                         max = 100_000,
                                         onValueChange,
                                         ...props
                                     }: AmountInputProps & { value?: string; onChange?: (e: any) => void }) => {
    // const [value, setValue] = React.useState("");
    const [internalValue, setInternalValue] = React.useState(formValue || "");

    React.useEffect(() => {
        if (formValue !== undefined) {
            const formatted = `₦${Number(formValue).toFixed(2)}`;
            setInternalValue(formatted);
        }
    }, [formValue, internalValue]);

    const formatValue = (value: string) => {
        let cleanedValue = value.replace(/\D/g, "");
        if (!cleanedValue) return {raw: "0", formatted: `₦0.00`};
        let number = (parseFloat(cleanedValue) / 100).toFixed(2);
        return {raw: number, formatted: `₦${number}`};
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value.replace(/\D/g, "");
        const number = Number(raw) / 100;
        if (number > max) return;

        const formatted = `₦${number.toFixed(2)}`;
        const isValid = number >= min && number <= max;

        setInternalValue(formatted);

        formOnChange?.(number); // pass number directly to RHF
        onValueChange?.(number.toString(), formatted, isValid);
    };

    const cleanedValue = Number(internalValue.replace(/[^0-9.]/g, ""));
    const isValid = cleanedValue >= min && cleanedValue <= max;

    const handleGridClick = (num: number) => {
        const formatted = `₦${num.toFixed(2)}`;
        setInternalValue(formatted);
        formOnChange?.(num);
        onValueChange?.(num.toString(), formatted, num >= min && num <= max);
    };

    return (
        <AmountInputComponentStyle {...wrapperProps}>
            {includeGridBtn &&
                <div className={"grid-amt-btn"}>
                    <LabelStyle>Choose an amount</LabelStyle>
                    <Grid className={"grid-cols-4 grid"} $columns={"repeat(3, minmax(0, 1fr))"}>
                        {[100, 200, 500, 1000, 2000].map((amt) => (
                            <Col
                                key={amt}
                                $span={1}
                                className="rounded-gray-card m-auto"
                                onClick={() => handleGridClick(amt)}
                            >
                                <h4 className="title grotesk-fnt">₦{amt.toFixed(2)}</h4>
                            </Col>
                        ))}
                    </Grid>
                </div>
            }
            <div className={"amt-input-wrapper"}>
                {(label || message) && (
                    <div className="input-title">
                        {label && <LabelStyle className="rb-label" htmlFor={name || "amount"}>{label}</LabelStyle>}
                        {message && <span className="message">{message}</span>}
                    </div>
                )}
                <div className={"cnt-input *:w-full"}>
                    <InputComponent
                        {...props}
                        onKeyDown={(e) => {
                            if (e.ctrlKey && e.key.toLowerCase() === "a") {
                                e.preventDefault()
                            }
                        }}
                        className={`${isValid ? "active" : ""}`}
                        $variant={"text"}
                        type={"text"}
                        value={internalValue}
                        onChange={handleChange}
                        placeholder="₦0.00"
                        name={name || "amount"}
                        autoCorrect={"off"}
                        autoCapitalize={"off"}
                        autoSave={"off"}
                        autoComplete={"off"}
                    />
                </div>
            </div>
        </AmountInputComponentStyle>
    )
}


export const AmountInputComponentC = ({
                                         value: formValue,
                                         onChange: formOnChange,
                                         includeGridBtn,
                                         wrapperProps,
                                         label,
                                         message,
                                         name,
                                         min = 50,
                                         max = 100_000,
                                         onValueChange,
                                         ...props
                                     }: AmountInputProps & { value?: string; onChange?: (e: any) => void }) => {
    const [internalValue, setInternalValue] = React.useState(formValue || "");

    // keep internal state synced with form value
    React.useEffect(() => {
        if (formValue !== undefined && formValue !== internalValue) {
            const formatted = `₦${Number(formValue).toFixed(2)}`;
            setInternalValue(formatted);
        }
    }, [formValue]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value.replace(/\D/g, "");
        const number = Number(raw) / 100;
        const formatted = `₦${number.toFixed(2)}`;
        const isValid = number >= min && number <= max;

        setInternalValue(formatted);

        formOnChange?.(number);
        onValueChange?.(number.toString(), formatted, isValid);
    };

    const handleGridClick = (num: number) => {
        const formatted = `₦${num.toFixed(2)}`;
        setInternalValue(formatted);
        formOnChange?.(num);
        onValueChange?.(num.toString(), formatted, num >= min && num <= max);
    };

    return (
        <AmountInputComponentStyle {...wrapperProps}>
            {includeGridBtn && (
                <div className="grid-amt-btn">
                    <LabelStyle>Choose an amount</LabelStyle>
                    <Grid className="grid-cols-4 grid" $columns="repeat(3, minmax(0, 1fr))">
                        {[100, 200, 500, 1000, 2000].map((amt) => (
                            <Col key={amt} $span={1} className="rounded-gray-card m-auto" onClick={() => handleGridClick(amt)}>
                                <h4 className="title grotesk-fnt">₦{amt.toFixed(2)}</h4>
                            </Col>
                        ))}
                    </Grid>
                </div>
            )}
            <div className="amt-input-wrapper">
                {(label || message) && (
                    <div className="input-title">
                        {label && <LabelStyle className="rb-label" htmlFor={name || "amount"}>{label}</LabelStyle>}
                        {message && <span className="message">{message}</span>}
                    </div>
                )}
                <div className="cnt-input">
                    <InputComponent
                        {...props}
                        value={internalValue}
                        onChange={handleChange}
                        placeholder="₦0.00"
                        name={name || "amount"}
                    />
                </div>
            </div>
        </AmountInputComponentStyle>
    );
};
